const interfaceTranslations = {
  selectedCountryAriaLabel: "Țara selectată",
  noCountrySelected: "Nicio țară selectată",
  countryListAriaLabel: "Lista țărilor",
  searchPlaceholder: "Căutare",
  zeroSearchResults: "Nici un rezultat gasit",
  oneSearchResult: "1 rezultat găsit",
  multipleSearchResults: "${count} rezultate găsite",
  // additional countries (not supported by country-list library)
  ac: "Insula Ascensiunii",
  xk: "Kosovo"
};
export default interfaceTranslations;